import React from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import fetch from 'isomorphic-fetch';
import Collapsible from 'react-collapsible';
import { setCurrentSection } from '../../actions/globalConfig';
import { checkHttpStatus, parseJSON } from '../../utils';
import { GenericMetadata, TopSnapshotsView } from '../../components';
import './styles.scss';

const defaultProps = {
  sectionName: 'Members'
}

class MemberIndexView extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      photographersAllTime:[],
      photographersThisWeek:[],
      curatorsAllTime: [],
      curatorsThisWeek: [],
      topMembers: [],
      newMembers: []
    };
  }

  componentWillMount(){
    this.fetchTopMembers();
    this.props.dispatch(setCurrentSection(this.props.sectionName));
  }

  fetchTopMembers() {
    return; fetch(`/get_top_members.json`, {
      headers: {
        'Accept': 'application/json, text/javascript, */*; q=0.01',
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      }
    })
    .then(checkHttpStatus)
    .then(parseJSON)
    .then( (response) => {
      this.setState({
        topSnapshots: response.data.top_snapshots,
        photographersAllTime: response.data.photographersAllTime,
        photographersThisWeek: response.data.photographersThisWeek,
        curatorsAllTime: response.data.curatorsAllTime,
        curatorsThisWeek: response.data.curatorsThisWeek,
        topMembers: response.data.top_members,
        newMembers: response.data.new_members,
      });
    });
  }

  render() {
    const {
      topSnapshots,
      photographersAllTime,
      photographersThisWeek,
      curatorsAllTime,
      curatorsThisWeek,
      topMembers,
      newMembers
    } = this.state;
    return (
      <div id="member-index">
        <div className="container-fluid content">
          {topSnapshots &&
          <TopSnapshotsView snapshotsData={topSnapshots} />
          }
          <div className="row mb-50">
            <Collapsible
              trigger={(<span>Top Snapshot Photographers - All Time</span>)}
              open={true}
              triggerClassName="result-type-header text-uppercase container-rounded u-textSize-18 text-upper text-center"
              triggerOpenedClassName="result-type-header is-open text-uppercase container-top-rounded u-textSize-18 text-upper text-center"
              contentOuterClassName="info-box-content u-textSize-18 container-bottom-rounded"
              contentInnerClassName="results-inner-wrapper text-center"
            >
              {photographersAllTime.map((photographer, index) => {
                if(!photographer.username) return null;
                return (
                  <Link to={`/members/${encodeURIComponent(photographer.username)}`} className="user-name" key={index}>
                    {photographer.username}
                  </Link>
                );
              })}
            </Collapsible>
          </div>
          <div className="row mb-50">
            <Collapsible
              trigger={(<span>Top Snapshot Photographers - This Week</span>)}
              open={true}
              triggerClassName="result-type-header text-uppercase container-rounded u-textSize-18 text-upper text-center"
              triggerOpenedClassName="result-type-header is-open text-uppercase container-top-rounded u-textSize-18 text-upper text-center"
              contentOuterClassName="info-box-content u-textSize-18 container-bottom-rounded"
              contentInnerClassName="results-inner-wrapper text-center"
            >
              {photographersThisWeek.map((photographer, index) => {
                if(!photographer.username) return null;
                return (
                  <Link to={`/members/${encodeURIComponent(photographer.username)}`} className="user-name" key={index}>
                    {photographer.username}
                  </Link>
                );
              })}
            </Collapsible>
          </div>
          <div className="row mb-50">
            <Collapsible
              trigger={(<span>Top Snapshot Curators - All Time</span>)}
              open={true}
              triggerClassName="result-type-header text-uppercase container-rounded u-textSize-18 text-upper text-center"
              triggerOpenedClassName="result-type-header is-open text-uppercase container-top-rounded u-textSize-18 text-upper text-center"
              contentOuterClassName="info-box-content u-textSize-18 container-bottom-rounded"
              contentInnerClassName="results-inner-wrapper text-center"
            >
              {curatorsAllTime.map((name, index) => {
                return (
                  <Link to={`/members/${encodeURIComponent(name)}`} className="user-name" key={index}>
                    {name}
                  </Link>
                );
              })}
            </Collapsible>
          </div>
          <div className="row mb-50">
            <Collapsible
              trigger={(<span>Top Snapshot Curators - This Week</span>)}
              open={true}
              triggerClassName="result-type-header text-uppercase container-rounded u-textSize-18 text-upper text-center"
              triggerOpenedClassName="result-type-header is-open text-uppercase container-top-rounded u-textSize-18 text-upper text-center"
              contentOuterClassName="info-box-content u-textSize-18 container-bottom-rounded"
              contentInnerClassName="results-inner-wrapper text-center"
            >
              {curatorsThisWeek.map((name, index) => {
                return (
                  <Link to={`/members/${encodeURIComponent(name)}`} className="user-name" key={index}>
                    {name}
                  </Link>
                );
              })}
            </Collapsible>
          </div>
          <div className="row mb-50">
            <Collapsible
              trigger={(<span>Welcome New Members</span>)}
              open={true}
              triggerClassName="result-type-header text-uppercase container-rounded u-textSize-18 text-upper text-center"
              triggerOpenedClassName="result-type-header is-open text-uppercase container-top-rounded u-textSize-18 text-upper text-center"
              contentOuterClassName="info-box-content u-textSize-18 container-bottom-rounded"
              contentInnerClassName="results-inner-wrapper text-center"
            >
              {newMembers.map((name, index) => {
                return (
                  <Link to={`/members/${encodeURIComponent(name)}`} className="user-name" key={index}>
                    {name}
                  </Link>
                );
              })}
            </Collapsible>
          </div>
        </div>
      </div>
    );
  }
}

MemberIndexView.defaultProps = defaultProps;

export default connect(null)(MemberIndexView);
